module.exports = __webpack_public_path__ + "static/media/coffee.6aa2582f.svg";